import HeroSection from "./components/HeroSection";
import AboutSection from "./components/AboutSection";
import FeaturesSection from "./components/FeaturesSection";
import TargetAudienceSection from "./components/TargetAudienceSection";
import DetailsSection from "./components/DetailsSection";
import CTASection from "./components/CTASection";
import FooterSection from "./components/FooterSection";
import type { ComponentType } from "react";
import { SectionShell, resolveSectionOrder, useDesign } from "../../context/design";

const SECTION_REGISTRY: Record<string, { label: string; Comp: ComponentType }> = {
  about: { label: "Über den Workshop", Comp: AboutSection },
  features: { label: "Was dich erwartet", Comp: FeaturesSection },
  target: { label: "Für wen?", Comp: TargetAudienceSection },
  details: { label: "Details", Comp: DetailsSection },
  cta: { label: "Anmeldebereich", Comp: CTASection },
};

export default function Home() {
  const { design } = useDesign();
  const order = resolveSectionOrder(design);

  return (
    <div className="min-h-screen bg-white">
      <HeroSection />
      {order.map((key) => {
        const entry = SECTION_REGISTRY[key];
        if (!entry) return null;
        const { label, Comp } = entry;
        return (
          <SectionShell key={key} sectionKey={key} label={label}>
            <Comp />
          </SectionShell>
        );
      })}
      <FooterSection />
    </div>
  );
}
